import Analytics from "../Analytics";
import { COUNTRY } from "utils/constants";
import { lower } from "utils/helpers";
import get from "lodash/get";
import includes from "lodash/includes";
import { CLICKSTREAM_ALLOWED_EVENTS } from "constants/AnalyticsTypeConstants";
import {
  constructClickStreamEventData,
  constructClickStreamPayload,
  postClickStreamRequest
} from "../utils/helpers";

class ClickStreamAnalytics extends Analytics {
  pushEvent(event, data, message, reduxStore, country = lower(COUNTRY)) {
    /**
     * Receives events from AnalyticsFactory and pushes
     * @param {string} event type of event provided by analyticsConstructor, which triggers based on type of action executed
     * @param {data} data data associated with the type of redux action executed
     */
    const allowedClickstreamEvent = includes(
      CLICKSTREAM_ALLOWED_EVENTS,
      `${event}`
    );
    if (allowedClickstreamEvent) {
      const clickstreamEventData = constructClickStreamEventData(
        event,
        data,
        reduxStore
      );
      if (get(clickstreamEventData, "event.name", false)) {
        const clickStreamPayload = constructClickStreamPayload(
          clickstreamEventData,
          reduxStore,
          country
        );

        postClickStreamRequest(clickStreamPayload);
      }
    }
  }
}

export default new ClickStreamAnalytics();
